import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { SermonProvider } from "./contexts/SermonContext";
import { ColumnProvider } from "./contexts/ColumnContext";
import { ModalProvider } from "./contexts/ModalContext";
import GlobalStyle from "./style/GlobalStyle";
import Router from "./Router";
import Modal from "./components/organisms/Modal";

import { Analytics } from "@vercel/analytics/react";

declare global {
  interface Window {
    kakao: any;
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SermonProvider>
          <ColumnProvider>
            <ModalProvider>
              <GlobalStyle />
              <Router />
              <Modal />
              <Analytics />
            </ModalProvider>
          </ColumnProvider>
        </SermonProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
